import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { LogOut, ChevronDown } from 'lucide-react'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useAuthStore } from '@/store'
import { useSignOutMutation } from '@/hooks/useAuthActions'
import FallbackImage from '../../assets/fallback.svg'
import AccountSettingsIcon from '../../assets/accountsettings.svg'

export const UserMenu: FC = () => {
    const navigate = useNavigate()
    const { user } = useAuthStore()
    const signOut = useSignOutMutation()

    const handleLogout = () => {
        signOut.mutate()
    }

    const handleAccountSettings = () => {
        navigate('/account-settings')
    }

    // Get user display name
    const displayName = user ? `${user.fullName}` : 'Oderinde Caleb'

    const displayEmail = user?.email || 'Oderindecaleb@Ogaboss.io'

    // const initials = displayName
    //     .split(' ')
    //     .map(n => n[0])
    //     .join('')
    //     .toUpperCase()

    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-2 ">
                <ChevronDown className="h-4 w-4 text-muted-foreground" />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-64">
                <DropdownMenuLabel className="font-normal">
                    <div className="flex items-center gap-3">
                        <img alt="Fallback Image" src={FallbackImage} />
                        <div className="flex flex-col space-y-1">
                            <p className="text-sm font-medium leading-none">
                                {displayName}
                            </p>
                            <p className="text-xs leading-none text-muted-foreground">
                                {displayEmail}
                            </p>
                        </div>
                    </div>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                    onClick={handleAccountSettings}
                    className="cursor-pointer"
                >
                    <img
                        alt="Account settings Image"
                        src={AccountSettingsIcon}
                    />
                    <span>Account Settings</span>
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                    onClick={handleLogout}
                    className="cursor-pointer text-destructive focus:text-destructive"
                >
                    <LogOut className="mr-2 h-4 w-4 text-red-500" />
                    <span>Logout</span>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
